module.exports = __webpack_public_path__ + "img/Tomas.2c36396d.jpeg";